import { Clock, Download, Euro, FileText, Upload } from 'lucide-react'
import { motion } from 'framer-motion'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import '../../css/StartPage.css'

const ESTIMATED_DURATION_RANGE = '15-20'

const Hero = ({ onStart, onImportFile }) => {
	const { t } = useTranslation('startPage')
	const fileInputRef = useRef(null)

	const handleFileChange = e => {
		const file = e.target.files?.[0]
		e.target.value = ''
		if (file) onImportFile(file)
	}

	return (
		<section className='hero-section'>
			<motion.div
				initial={{ opacity: 0, y: 10 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.5 }}
			>
				<h2 className='hero-title'>{t('hero.title')}</h2>

				<p className='hero-text'>{t('hero.text')}</p>

				<div className='hero-badges'>
					<span className='hero-badge'>
						<Clock size={18} />
						{t('hero.durationBadge', { range: ESTIMATED_DURATION_RANGE })}
					</span>
					<span className='hero-badge'>
						<Euro size={18} />
						{t('hero.freeBadge')}
					</span>
				</div>

				<div className='hero-hint'>
					<FileText size={18} />
					{t('hero.hint')}
				</div>

				<button className='btn-primary hero-start-btn' onClick={onStart}>
					{t('hero.startButton')}
				</button>

				<div className='hero-secondary-actions'>
					<a className='hero-secondary-link' href='/formular.pdf' download>
						<span className='hero-secondary-link-inner'>
							<Download size={16} />
							{t('hero.downloadBlankLink')}
						</span>
					</a>

					<button
						type='button'
						className='hero-secondary-link hero-import-btn'
						onClick={() => fileInputRef.current?.click()}
					>
						<span className='hero-secondary-link-inner'>
							<Upload size={16} />
							{t('hero.uploadFilledLink')}
						</span>
					</button>
				</div>
				<p className='hero-import-hint'>{t('hero.uploadFilledHint')}</p>
				<input
					ref={fileInputRef}
					type='file'
					accept='application/pdf'
					hidden
					onChange={handleFileChange}
				/>
			</motion.div>
		</section>
	)
}

export default Hero
